// Components
import NostoRecommendations from '@componentsJS/nosto/recommendations';
import { initQuantity } from '@componentsJS/quantity';
import initQuicklook from '@componentsJS/quicklook';
import initBackToTop from '@componentsJS/back-to-top';
import { initMobileFilterNav } from '@componentsJS/mobile-filter-nav';
import initNotification from '@componentsJS/notification';
// import { initOverlaySearch } from '@componentsJS/overlay-search';
// import OverlaySearch from '@componentsJS/overlay-search-v2';
import { nostoInitGlobalEvents } from '@componentsJS/nosto/events';
import OverlaySearchNosto from '@componentsJS/overlay-search-nosto';

// Items initialized on page loaded
import { initWishlist } from '@componentsJS/wishlist';
import initChat from '@componentsJS/chat';

// Other sections
// import initRecommendedProducts from '@sectionsJS/recommended-products';
import heroBanner from '@sectionsJS/hero-banner';
import initLoyalty from '@sectionsJS/loyalty';

const refreshElements = () => {
  $(window).trigger('resize');
  $(window).trigger('scroll');
};

$(async () => {
  // Components
  const NostoRecommendationsInstance = new NostoRecommendations();
  initQuantity();
  initQuicklook();
  initBackToTop();
  initMobileFilterNav();
  initNotification();
  // initOverlaySearch();
  // const overlaySearch = new OverlaySearch();
  nostoInitGlobalEvents();
  new OverlaySearchNosto(NostoRecommendationsInstance);

  // Other sections
  heroBanner();
  initLoyalty();
});

// Need to wait for third party code to be loaded (_swat object)
$(window).on('load', async () => {
  // Helps setting up z-index for toaster notification
  // if ($('.cc-compliance').length) {
  //   $('body').addClass('has-compliance');
  // }

  // Need to wait for cart initialization (404 page, cart)
  // This function is also used on the PDP
  // await initRecommendedProducts();

  initWishlist();
  initChat();
  refreshElements();
});
